import { createFileRoute } from '@tanstack/react-router'
import { PlanBookingRoutePage } from '@/components/booking/plan-booking-page'

export const Route = createFileRoute('/booking/plan/$versionId')({
  component: PlanBookingRoutePage,
})
